import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import {showAddGlobalButton} from '../../components/permissions/permissions';
import MenusTable from './MenusTable';
import MenuAddTranslationDialog from './MenuAddTranslationDialog';
import {Heading} from "../../components/heading/heading";
import ScrollToTop from '../../components/scroll-top/ScrollToTop';
import {
    fetchMenus,
    createMenuTranslation
} from './thunks';
import {
    fetchSites,
} from '../sites/thunks';

class MenusGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            menuId: null,
        };
    }

    componentWillMount() {
        this.props.fetchMenus();
        this.props.fetchSites();
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleClickOpenAddTranslationDialog = (menuId) => {
        this.setState({
            open: true,
            menuId: menuId
        });
    }

    handleAddMenuTranslationSubmit = (formProps) => {
        this.props.createMenuTranslation(this.state.menuId, formProps)
        this.setState({
            open: false,
            menuId: null
        });
    }

    handleRequestCloseTranslationDialog = () => {
        this.props.fetchSites();
        this.setState({
            open: false,
            menuId: null
        });
    }

    render() {
        return (
            this.props.loading !== true &&
            <div>
               <Heading
                    title={'Menus List'}
                    buttonTitle={'Add New Menu'}
                    buttonAction={'menus/new'}
                    showButton={showAddGlobalButton}
                    disabled={true}
                />
                <MenusTable
                    menus={this.props.menus}
                    sites={this.props.sites}
                    classes={this.props.classes}
                    handleClickOpen={this.handleClickOpenAddTranslationDialog.bind(this)}
                />
                <MenuAddTranslationDialog
                    menuId={this.state.menuId}
                    menus={this.props.menus}
                    sites={this.props.sites}
                    open={this.state.open}
                    classes={this.props.classes}
                    handleClose={this.handleRequestCloseTranslationDialog.bind(this)}
                    handleFormSubmit={this.handleAddMenuTranslationSubmit.bind(this)}
                />
                <ScrollToTop />
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    menus: state.menus.all,
    sites: state.sites.all,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchMenus,
    fetchSites,
    createMenuTranslation,
})(withStyles(styles)(MenusGrid));


// WEBPACK FOOTER //
// ./src/containers/menus/index.js